import {NavLink, Outlet} from "react-router-dom";
import {AppBar, Toolbar, IconButton, Box, Grid, Container} from "@mui/material";
import HomeWorkIcon from '@mui/icons-material/HomeWorkOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonthOutlined';
import AddHomeIcon from '@mui/icons-material/AddHomeOutlined';
import PeopleIcon from '@mui/icons-material/PeopleOutlined';
import CottageIcon from '@mui/icons-material/Cottage';
import '../../App.css';
import PageTitle from "../../components/PageTitle";
import AuthProvider from '../../hooks/authProvider';
import {isPartner, isSuperAdmin} from '../../auth/permissions';

export default function MobileMenu() {
    return (
        <>
            <Container maxWidth='md'>
                <PageTitle title="Мобільне меню"/>
                <Outlet/>
            </Container>
            <Box className='mobile_downmenu_wrapper'>
                <Box className='spacer_bottom' style={{height: '67px'}}/>
                <Box className='zIndex9999' sx={{flexGrow: 1}}>
                    <AppBar position="fixed" color="backgrounds" sx={{top: 'auto', bottom: 0}}>
                        <Container maxWidth='md'>
                            <Toolbar>
                                <Grid container spacing={1} style={{display: 'flex', justifyContent: 'end'}}>
                                    <Grid item xs={2}>
                                        <NavLink to='/calendar'>
                                            <IconButton size='large'>
                                                <CalendarMonthIcon fontSize='large'/>
                                            </IconButton>
                                        </NavLink>
                                    </Grid>
                                    {isSuperAdmin(AuthProvider.user) && <Grid item xs={2}>
                                        <NavLink to='/adminH123H/publication'><IconButton size='large'><CottageIcon fontSize='large'/></IconButton></NavLink>
                                    </Grid>}
                                    <Grid item xs={2}>
                                        <NavLink to='/mobile/objects'>
                                            <IconButton size='large'>
                                                <HomeWorkIcon fontSize='large'/>
                                            </IconButton>
                                        </NavLink>
                                    </Grid>
                                    {/* <Grid item xs={2}>
                                        <NavLink to='/mobile/a'>
                                            <IconButton size='large'>
                                                <CalendarMonthIcon fontSize='large' />
                                            </IconButton>
                                        </NavLink>
                                    </Grid>
                                    */}
                                    <Grid item xs={2}>
                                        <NavLink to='/mobile/new-object'>
                                            <IconButton size='large'>
                                                <AddHomeIcon fontSize='large'/>
                                            </IconButton>
                                        </NavLink>
                                    </Grid>
                                    {isSuperAdmin(AuthProvider.user) && <Grid item xs={2}>
                                        <NavLink to='/mobile/owners'>
                                            <IconButton size='large'>
                                                <PeopleIcon fontSize='large'/>
                                            </IconButton>
                                        </NavLink>
                                    </Grid>}
                                    <Grid item xs={2}>
                                        <NavLink to='/'>
                                            <IconButton size='large'>
                                                <CottageIcon fontSize='large'/>
                                            </IconButton>
                                        </NavLink>
                                    </Grid>
                                </Grid>
                            </Toolbar>
                        </Container>
                    </AppBar>
                </Box>
            </Box>
        </>
    )
}
